/**
 * A Regisztrációk oldal ezzel jelzi a Layoutnak, hogy változott a függőben
 * lévők száma. Enélkül a menü jelzése a következő körig (60 mp) állna.
 *
 * Azért ablak-esemény és nem context: a két komponens nincs egymással
 * kapcsolatban, és a jelzés se nem kritikus, se nem gyakori.
 */
export const REGISTRATIONS_CHANGED_EVENT = 'ct:registrations-changed';

export const notifyRegistrationsChanged = () =>
  window.dispatchEvent(new Event(REGISTRATIONS_CHANGED_EVENT));
